import EventManager from '@blade/common/utils/rzcanvas/event-manager';
import { mergeOptions, drawLayeredCircle } from '@blade/common/utils/rzcanvas/util';
import { calculator } from './calculate';
export const stateMap = {
    none: 0,
    circle: 1,
    screenShot: 2,
    drawRects: 3,
    moveCanvas: 4,
};
export const mouseType = {
    move: 'move',
    down: 'down',
    up: 'up',
};
export const Events = {
    drawCircles: 'drawCircles',
    drawCircleDone: 'drawCircleDone',
    changeDrawState: 'changeDrawState',
};
const _drawCircleOption = {
    lineColor: ['#fa6400', 'rgba(250, 100, 0, 0.54)'],
    opacity: 1,
    radius: 15,
};
const _config = {
    ContainerStyle: {
        width: 0,
        heights: 0,
    },
    circleLength: 10,
};
export class Editor extends EventManager {
    state = stateMap.circle;
    canvasCtx;
    containerStyle = {};
    options = { drawCircleOption: _drawCircleOption };
    config = {};
    image;
    circles = [];
    transformCircles = [];
    scale = 0;
    zoomLevel = 1; //
    canvas = null;
    rect = {};
    zoomedRadius = 0;
    constructor(canvasElem, config = _config, options = {}, image) {
        super();
        if (!canvasElem) {
            console.log('canvas Element no found | 没有 canvas Element');
        }
        const { containerStyle, circleLength, imageSize } = config;
        this.config = { containerStyle, circleLength, imageSize };
        mergeOptions(this.options, options);
        try {
            this.init(canvasElem, containerStyle, image);
        }
        catch (e) { }
        this.zoomedRadius = this.options.radius;
    }
    init(canvasElem, containerStyle, image) {
        this.canvas = canvasElem;
        const { width, height } = containerStyle;
        if (!width || !height) {
            throw new Error(`width is ${width},height is ${height}`);
        }
        this.canvas.width = width;
        this.canvas.height = height;
        this.canvasCtx = this.canvas.getContext('2d');
        this.containerStyle = containerStyle;
        this.image = image;
        this.drawImage();
    }
    drawImage() {
        const { width: containerWidth, height: containerHeight } = this.containerStyle;
        const { imageSize: { width: imageWidth, height: imageHeight }, } = this.config;
        this.rect = calculator(imageWidth, imageHeight, containerWidth, containerHeight);
        const { scale, vertexes } = this.rect;
        const [vertexStart, vertexEnd] = vertexes;
        // const scaleImageWidth = imageWidth / scale; // imageWidth;
        // const scaleImageHeight = imageHeight / scale; // imageHeight;
        const scaleImageWidth = containerWidth; // imageWidth;
        const scaleImageHeight = containerHeight;
        /**
         * @param image Image
         * @param vertexStart 起点坐标
         * @param vertexStart.x // 绘画的起点横坐标
         * @param vertexStart.y // 绘画的起点纵坐标
         * @param scaleImageWidth / scale 后图片的宽度
         * @param scaleImageHeight scale 后图片的高度
         * */
        this.canvasCtx.drawImage(this.image, vertexStart.x, vertexStart.y, scaleImageWidth, scaleImageHeight);
    }
    addCircle(vertex) {
        if (this.state !== stateMap.circle) {
            return;
        }
        const { circleLength } = this.config;
        if (this.circles.length >= circleLength) {
            this.emit(Events.drawCircleDone, this.transformCircles);
            return;
        }
        const { drawCircleOption, radius } = this.options;
        if (!this.isInImageArea(vertex, radius)) {
            return;
        }
        const ctx = this.canvasCtx;
        const res = { weight: radius * this.zoomLevel };
        this.circles.push({ vertex, options: res });
        this.updateOuterCircle();
        if (this.circles.length >= circleLength) {
            this.emit(Events.drawCircleDone, this.transformCircles);
        }
    }
    addCircles(vertexes) {
        const shrinkedVertexes = [];
        for (let i = 0; i < vertexes.length; i++) {
            const { vertex: originVertext, ...rest } = vertexes[i];
            shrinkedVertexes.push({ vertex: this.shrinkVertex(originVertext), ...rest });
        }
        this.circles = shrinkedVertexes;
    }
    isCircleExist(vertex) {
        let index = -1;
        if (!this.circles.length) {
            return index;
        }
        // const { radius } = this.options;
        // const scaledRadius = radius*this.zoomLevel;
        const { scale } = this.rect;
        let { radius } = this.options;
        let i = 0;
        for (; i < this.circles.length; i++) {
            const { vertex: targetVertex, options } = this.circles[i];
            mergeOptions(this.options.drawCircleOption, options);
            radius = this.options.drawCircleOption.radius;
            const scaledRadius = (radius * 2) / scale > 30 ? (radius / scale) * 2 * this.zoomLevel : 15 * 2 * this.zoomLevel;
            const distanceXY = this.distanceTwoPoints(vertex, targetVertex);
            if (distanceXY <= scaledRadius) {
                index = i;
            }
        }
        return index;
    }
    distanceTwoPoints(eventVertex, targetCircle) {
        const { x: originX, y: originY } = eventVertex;
        const { x: targetX, y: targetY } = targetCircle;
        const distance = Math.sqrt(Math.pow(targetX - originX, 2) + Math.pow(targetY - originY, 2));
        return Math.ceil(distance);
    }
    removeCircle(index) {
        this.circles.splice(index, 1);
        // this.emit(Events.drawCircles, this.circles)
        this.updateOuterCircle();
        // this.drawCircles();
    }
    drawCircles() {
        this.clearAndDrawImage();
        let { drawCircleOption, radius } = this.options;
        for (const circle of this.circles) {
            mergeOptions(drawCircleOption, circle.options);
            radius = circle.options?.radius ?? radius;
            const ctx = this.canvasCtx;
            const { scale } = this.rect;
            // console.log('radius:', circle);
            const currRadius = (radius * 2) / scale > 30 ? radius / scale : 15;
            const res = { ...drawCircleOption, weight: radius * this.zoomLevel };
            drawLayeredCircle(ctx, circle.vertex, currRadius * this.zoomLevel, res);
        }
        // this.updateOuterCircle();
    }
    updateOuterCircle() {
        const { scale } = this.rect;
        const transformedXY = [];
        for (let i = 0; i < this.circles.length; i++) {
            const { vertex: editorVertex, ...rest } = this.circles[i];
            transformedXY.push({ vertex: this.transformVertex(editorVertex), ...rest });
        }
        this.emit(Events.drawCircles, transformedXY);
    }
    isInImageArea(vertex, radius) {
        const { vertexes } = this.rect;
        const [vertexStart, vertexEnd] = vertexes;
        /**
         * 大于左上角的坐标 x y
         * 小于右下角的坐标 x y
         * 则落入区域
         */
        const flag = vertex.x - radius - radius * this.zoomLevel >= vertexStart.x &&
            vertex.y - radius - radius * this.zoomLevel >= vertexStart.y &&
            vertex.x + radius + radius * this.zoomLevel <= vertexEnd.x &&
            vertex.y + radius + radius * this.zoomLevel <= vertexEnd.y;
        return flag;
    }
    /**
     *
     * @param scale
     * @param widthScale
     * @param heightScale
     * @param vertexes
     */
    transformVertex(vertex) {
        const { scale, vertexes, widthScale, heightScale } = this.rect;
        const [vertexStart] = vertexes;
        const x = (vertex.x - vertexStart.x) * widthScale;
        const y = (vertex.y - vertexStart.y) * heightScale;
        const relativeX = x / this.config.imageSize.width;
        const relativeY = y / this.config.imageSize.height;
        const transformVertex = { x: relativeX, y: relativeY };
        return transformVertex;
    }
    shrinkVertex(vertex) {
        const { scale, vertexes, widthScale, heightScale } = this.rect;
        const [vertexStart] = vertexes;
        const relativeX = vertex.x * this.config.imageSize.width;
        const relativeY = vertex.y * this.config.imageSize.height;
        const x = relativeX / widthScale + vertexStart.x;
        const y = relativeY / heightScale + vertexStart.y;
        const transformVertex = { x, y };
        return transformVertex;
    }
    zoom(zoom) {
        this.zoomLevel = zoom;
        this.zoomedRadius = this.options.radius ? this.options.radius / this.zoomLevel : 1;
        switch (this.state) {
            // 圆跟着缩放
            case stateMap.circle:
                this.drawCircles();
        }
    }
    clear() {
        const { width, height } = this.containerStyle;
        const ctx = this.canvasCtx;
        this.clearCanvas(ctx, { width, height });
    }
    clearAndDrawImage() {
        this.clear();
        this.drawImage();
    }
    dispose() {
        // this.changeState(stateMap.none);
        this.clear();
    }
    clearCanvas(ctx, rect) {
        const { width, height } = rect;
        ctx?.clearRect(0, 0, width, height);
    }
}
